import useApi from "@action.sustainability/storybook-dashboard/utils/fetching";
import { BasicSpinner } from "@action.sustainability/storybook-dashboard/spinners/basicSpinner";
import { Link } from "react-router-dom";
import Octicon from "react-octicon";
import Im from "immutable";
import { CompanyInviteButton } from "./invite";
import { Hide } from "./utils";
import { useCompanyPermission } from "./hooks";
import { AcceptRejectButtons } from "./inviteItem";
import SiteInviteList from "./siteInvite";

const fullName = (member) => {
  return `${member.getIn(["user", "first_name"])} ${member.getIn([
    "user",
    "last_name",
  ])}`;
};

function MemberRow({ member }) {
  return (
    <tr>
      <td>{fullName(member)}</td>
      <td>{member.getIn(["user", "email"])}</td>
      {/* Role is hidden for now as requested by Charles */}
      {/* <td>{member.getIn(["auth", "name"])}</td> */}
    </tr>
  );
}

function InviteRow({ invite }) {
  return (
    <tr>
      <td>{invite.get("email")}</td>
      {/* <td>{invite.getIn(["auth", "name"])}</td> */}
      <td>
        <AcceptRejectButtons
          invite={invite}
          isRequest={false}
          hide={!invite?.get("is_request")}
        />
      </td>
    </tr>
  );
}

function CompanyInviteList({ companyId }) {
  const { data, isLoading } = useApi(`/api/company/${companyId}/invite/`);

  if (isLoading) return <BasicSpinner />;
  if (!data?.size) {
    return null;
  }

  return (
    <>
      <h5 className="font-weight-bold">Pending invitations</h5>
      <table className="table mb-5">
        <thead>
          <tr>
            <th scope="col">Email</th>
            {/* <th scope="col">Role</th> */}
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((invite, i) => (
            <InviteRow key={i} invite={invite} />
          ))}
        </tbody>
      </table>
    </>
  );
}

function CompanyMemberList({ companyId }) {
  const { data, isLoading } = useApi(`/api/company/${companyId}/member/`);
  const { isAdmin } = useCompanyPermission({ companyId });
  console.log("CompanyMemberList", data?.toJS());

  if (isLoading) {
    return <BasicSpinner />;
  }
  if (!data?.size) {
    return null;
  }

  console.log(data?.toJS(), "CompanyData");

  return (
    <>
      <Hide when={!isAdmin}>
        <CompanyInviteButton companyId={companyId} />
        <CompanyInviteList companyId={companyId} />
      </Hide>
      <h5 className="font-weight-bold">Active users</h5>
      <table className="table mb-5">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
          </tr>
        </thead>
        <tbody>
          {data.map((m, i) => (
            <MemberRow key={i} member={m} />
          ))}
        </tbody>
      </table>
    </>
  );
}

export default function CompanyDetails({ companyId }) {
  // let companyId = company?.get("uid")
  const { data: company, isLoading } = useApi(`/api/company/${companyId}/`);
  const { data: clients, isLoading: isLoadingClients } = useApi(`/api/client/`);
  const clientIds = Im.Set((clients || Im.List()).map((i) => i.get("uid")));
  const isClient = clientIds.has(company?.get("uid"));

  return (
    <>
      <Link to={`/company/${companyId}/catalog`}>
        <button className="btn btn-link text-muted">
          <p
            className="text-muted text-underline mb-5"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            <Octicon name="chevron-left" />
            Back to assets catalogue
          </p>
        </button>
      </Link>
      <Link to={`/catalog`}>
        <button className="btn btn-link text-muted float-right">
          <p
            className="text-muted text-underline mb-5"
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            My companies list
            <Octicon name="chevron-right" />
          </p>
        </button>
      </Link>
      <h2 className="mb-5 font-weight-bold">{company?.get("name")}</h2>
      <p className="text-muted">
        Invite new users to join this platform by clicking the 'Add new user'
        button and entering their email addresses. They will then have access to
        work with you on the supplier details.
      </p>
      <p className="text-muted">
        Please be aware that all users are granted the same level of access to
        the system.
      </p>
      <p className="text-muted">
        This page also allows you to view and manage the complete list of active
        users and pending invitations.
      </p>
      <div className="card shadow p-3 my-5 bg-white rounded border-0">
        <div className="card-body">
          <CompanyMemberList companyId={companyId} />
        </div>
      </div>

      <Hide when={!isClient}>
        <div className="card shadow p-3 my-5 bg-white rounded border-0">
          <div className="card-body">
            <SiteInviteList companyId={companyId} />
          </div>
        </div>
      </Hide>
    </>
  );
}
